import { Report } from "../../../Interfaces/TableInterfaces";
import {
  IManualSahraOrderTableReport,
  IManualSahraOrderTableSearchParam,
} from "../../../Interfaces/manualInterfaces";
import TableTemplate from "../../TableTemplate/tableTemplate";
import TableUI from "./TableUI";

interface IProps {
  getData: (
    searchParam: IManualSahraOrderTableSearchParam,
    offset: number | null,
    pageSize: number | null
  ) => Promise<Report<IManualSahraOrderTableReport>>;
  searchParam: IManualSahraOrderTableSearchParam;
}

const SahraOrderTable = ({ getData, searchParam }: IProps) => {
  return (
    <TableTemplate<
      IManualSahraOrderTableSearchParam,
      IManualSahraOrderTableReport
    >
      getDataTable={getData}
      TableUI={TableUI}
      showIsLoading
      initialSearchParameters={searchParam}
    />
  );
};

export default SahraOrderTable;
